import type { CoupleSpace, Ticket, TicketState } from '../../domain/types';

export const statusLabels: Record<TicketState, string> = {
  pending_response: '等待回应',
  accepted: '进行中',
  rejected: '已拒绝',
  pending_confirmation: '等待最终确认',
  completed: '已归档',
};

export interface HomeViewModel {
  space: CoupleSpace;
  tickets: Ticket[];
}

export function renderHomeView(container: HTMLElement, model: HomeViewModel): void {
  container.replaceChildren();
  const pending = model.tickets
    .filter((ticket) => ticket.state !== 'completed' && ticket.state !== 'rejected')
    .sort((left, right) => right.updatedAt.localeCompare(left.updatedAt))
    .slice(0, 3);
  const section = document.createElement('section');
  section.className = 'home-view stack';
  section.innerHTML = `
    <header class="home-hero stack">
      <p class="eyebrow">只保存在这台设备</p>
      <h1>${escapeText(model.space.spaceName)}</h1>
      <div class="couple-avatars" data-member-id="${model.space.memberId}">
        <span><b aria-hidden="true">${escapeText(model.space.selfAvatar)}</b>${escapeText(model.space.selfName)}</span>
        <span aria-hidden="true">♡</span>
        <span><b aria-hidden="true">${escapeText(model.space.partnerAvatar)}</b>${escapeText(model.space.partnerName)}</span>
      </div>
      ${model.space.peerReadyAt ? '<p class="muted">双方设备已确认就绪</p>' : ''}
      <p class="muted">${escapeText(anniversaryText(model.space))}</p>
    </header>
    <div class="ticket-create-actions" aria-label="创建单据">
      <a class="action-card action-card--reward" href="#create/reward"><span aria-hidden="true">🎁</span>奖励一下</a>
      <a class="action-card action-card--penalty" href="#create/penalty"><span aria-hidden="true">📝</span>小小惩罚</a>
    </div>
    <section class="stack" aria-labelledby="pending-title">
      <div class="section-heading"><h2 id="pending-title">最近待处理</h2><a href="#tickets">查看全部</a></div>
      <div class="ticket-cards" data-ticket-list></div>
    </section>
  `;
  const list = section.querySelector<HTMLElement>('[data-ticket-list]')!;
  if (pending.length === 0) {
    const empty = document.createElement('p');
    empty.className = 'empty-state';
    empty.textContent = '还没有待处理的单据，给彼此留下一张小票吧。';
    list.append(empty);
  } else {
    for (const ticket of pending) list.append(ticketCard(ticket));
  }
  container.append(section);
}

export function ticketCard(ticket: Ticket): HTMLElement {
  const link = document.createElement('a');
  link.className = `ticket-card ticket-card--${ticket.type}`;
  link.href = `#ticket/${encodeURIComponent(ticket.id)}`;
  link.innerHTML = `
    <span class="ticket-card__icon" aria-hidden="true">${ticket.type === 'reward' ? '🎁' : '📝'}</span>
    <span class="ticket-card__body"><b>${escapeText(ticket.title)}</b><small>${escapeText(ticket.outcome)}</small></span>
    <span class="status-badge status-badge--${ticket.state}">${statusLabels[ticket.state]}</span>
  `;
  return link;
}

function anniversaryText(space: CoupleSpace): string {
  return space.anniversary
    ? `纪念日 ${space.anniversary} · 继续收藏属于你们的小事`
    : `今天也要好好回应 ${space.partnerName}`;
}

function escapeText(value: string): string {
  const node = document.createElement('span');
  node.textContent = value;
  return node.innerHTML;
}
